import axios from 'axios';

const updateNotificationPreferences = async ({ preferences }) => {
  const response = await axios.put(
    `${process.env.REACT_APP_API_URL}/users/me/notification-preferences`,
    preferences
  );
  return response.data;
};

const notificationPreferencesService = {
  updateNotificationPreferences
};

export default notificationPreferencesService;
